import once from "@drupal/once";
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import persist from "@alpinejs/persist";
import tooltip from "@ryangjchandler/alpine-tooltip";

Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(
  tooltip.defaultProps({
    placement: "bottom",
  })
);
Alpine.magic("normalize", () => {
  return (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
});
window.Alpine = Alpine;
Alpine.start();

var $component = once("processed", ".component-search-algolia").shift();
if ($component) {
  import("../../templates/component/search-algolia/js/search-algolia");
}
var $component = once(
  "processed",
  ".component-search-algolia-combined"
).shift();
if ($component) {
  import(
    "../../templates/component/search-algolia-combined/js/search-algolia-combined"
  );
}
var $component = once("processed", ".component-jumbotron-hp").shift();
if ($component) {
  import("../../templates/component/jumbotron-hp/js/jumbotron-hp");
}
var $component = once("processed", ".component-numbers").shift();
if ($component) {
  import("../../templates/component/numbers/js/numbers");
}
var $component = once("processed", ".component-icon-slider").shift();
if ($component) {
  import("../../templates/component/icon-slider/js/icon-slider");
}
var $component = once("processed", ".component-article-slider").shift();
if ($component) {
  import("../../templates/component/article-slider/js/article-slider");
}
var $component = once("processed", ".component-app-featured").shift();
if ($component) {
  import("../../templates/component/app-featured/js/app-featured");
}
var $component = once("processed", ".component-reference-featured").shift();
if ($component) {
  import("../../templates/component/reference-featured/js/reference-featured");
}
var $component = once("processed", ".component-filter").shift();
if ($component) {
  import("../../templates/component/filter/js/filter");
}
var $component = once("processed", ".component-signpost").shift();
if ($component) {
  import("../../templates/component/signpost/js/signpost");
}
var $component = once("processed", ".component-reference-list").shift();
if ($component) {
  import("../../templates/component/reference-list/js/reference-list");
}
var $component = once("processed", ".component-gallery").shift();
if ($component) {
  import("../../templates/component/gallery/js/gallery");
}
var $component = once("processed", ".component-jumbotron-media").shift();
if ($component) {
  import("../../templates/component/jumbotron-media/js/jumbotron-media");
}
var $component = once(
  "processed",
  ".component-article-image-anotation"
).shift();
if ($component) {
  import(
    "../../templates/component/article-image-anotation/js/article-image-anotation"
  );
}
var $component = once("processed", ".component-lottie-animation").shift();
if ($component) {
  import("../../templates/component/lottie-animation/js/lottie-animation");
}
var $component = once("processed", ".component-hero-newsletter").shift();
if ($component) {
  import("../../templates/component/hero-newsletter/js/hero-newsletter");
}
var $component = once("processed", ".js-lightbox").shift();
if ($component) {
  import("../../templates/component/picture/js/picture");
}
